/* unplugin-vue-components disabled */import script from "./prompt-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./prompt-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./prompt-dialog.vue?vue&type=style&index=0&id=5a5eaa5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5eaa5a"]])

export default __exports__